import { useAuthentication } from '@cascade/react/authentication';
import * as authentication from '@cascade/react-dom/authentication';
import { HOME_PATH } from '#config/index.ts';
import { SessionPending } from '#views/session-pending/index.ts';
import { SignIn } from '#views/sign-in/index.ts';

export const DemoGate = () => {
  const { status } = useAuthentication();

  return (
    <authentication.DemoGate
      loading={<SessionPending status={status} />}
      unauthenticated={<SignIn />}
      homePath={HOME_PATH}
    />
  );
};
